import * as api from '../../services/reporting_exchange_rate/api_reporting_exchange_rate';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';


export function* fetchListReportingExchangeRateSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_REPORTING_EXCHANGE_RATE', callFetchListReportingExchangeRate, feathersApp);
}

function* callFetchListReportingExchangeRate(feathersApp, action) {
    const { filters, silent } = action;
    yield common.showProgressListTable(silent);
    try {
        const dataParams = {
            filters,
            list_type: 'reporting_exchange_rate'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield common.showErrorListTable(error);
    }
}


export function* saveReportingExchangeRateSaga(feathersApp) {
    yield takeEvery("SAVE_REPORTING_EXCHANGE_RATE", callSaveReportingExchangeRate, feathersApp);
}

function* callSaveReportingExchangeRate(feathersApp, action) {
    const { tenant, user, silent } = yield select();
    try {
        yield common.showProgressSaveRecord(silent);

        const params = { tenant, user, data: action.data };
        let result = yield call(api.saveReportingExchangeRate, feathersApp, params);

        const id = result && result.id;
        yield callFetchReportingExchangeRateForEdit(feathersApp, { id, silent: true });
        browserHistory.push(`/admin/reporting_exchange_rate/edit/${id}`);
        yield common.doneSaveRecord(result, 'Reporting exchange rate was saved');

    } catch (error) {
        yield common.showErrorSaveRecord(error);
    }
}

export function* deleteReportingExchangeRateSaga(feathersApp) {
    yield takeEvery('DELETE_REPORTING_EXCHANGE_RATE', callDeleteReportingExchangeRate, feathersApp);
}

function* callDeleteReportingExchangeRate(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        if (id) {
            const state = yield select();
            const { tenant, user } = state;
            const { id } = action;
            const params = { tenant, user, id };
            yield call(api.deleteReportingExchangeRate, feathersApp, params);
        }
        yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.REPORTING_EXCHANGE_RATE } });
        yield delay(2000);
        browserHistory.push('/admin/reporting_exchange_rate');


    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

export function* fetchReportingExchangeRateForEditSaga(feathersApp) {
    yield takeEvery('FETCH_REPORTING_EXCHANGE_RATE_FOR_EDIT', callFetchReportingExchangeRateForEdit, feathersApp);
}

function* callFetchReportingExchangeRateForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id, silent } = action;

    try {
        if (id) {
            yield common.showProgressDataById(silent);
            const fetchParams = { tenant, user, id };
            const doc = yield call(api.fetchReportingExchangeRateById, feathersApp, fetchParams);
            yield common.doneDataById(doc);
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}
